import { allowsFreeDownloads } from '../../../../../../../util/album';

/**
 * Retrieves the album given a membership group & photo
 *
 * @param {Object} albumMembershipGroup The membership we want the album for
 * @param {Object} photo the photo we want the album for
 * @returns {Object} the album
 */
export const getAlbumMembershipGroupAlbum = (albumMembershipGroup, photo) => {
  return albumMembershipGroup?.is_album
    ? albumMembershipGroup.album
    : photo.albums?.records?.[0];
};

export const photoIsEntitled = (
  albumMembershipGroup,
  entitledPurchases,
  photo,
) => {
  const isPictureDay = albumMembershipGroup?.is_album
    ? albumMembershipGroup?.album?.root_album_folder?.picture_day_enabled
    : albumMembershipGroup?.album_folder?.picture_day_enabled;

  const album = getAlbumMembershipGroupAlbum(albumMembershipGroup, photo);

  if (isPictureDay) {
    return entitledPurchases.includes(photo.id);
  }

  const hasViewAccess =
    !albumMembershipGroup ||
    albumMembershipGroup?.album_memberships_has_all_photos_access;

  return (
    entitledPurchases.includes(photo.id) ||
    (hasViewAccess && allowsFreeDownloads(album))
  );
};
